export default function WhoIAm() {
  return <section data-section-id="222417" id="la-nostra-missione-editoriale" className="bg-background py-24 md:py-40">
      <div className="mx-auto max-w-[800px] px-6 md:px-8">
        <div className="border-primary border-l-2 pl-6 md:pl-10">
          <h1 className="font-default text-foreground mb-6 text-[32px] font-bold tracking-tight">
            Chi siamo
          </h1>
          <div className="font-default text-foreground space-y-6 text-[18px] leading-[1.6] tracking-tight">
            <p className="first-letter:text-5xl first-letter:font-serif first-letter:mr-3 first-letter:float-left first-letter:text-primary">
              ImpiantiDentali.co è la guida in italiano realizzata con SkyDental, clinica dentale a Tirana. Raccogliamo in un unico posto le informazioni che un paziente italiano chiede prima di partire: il listino 2026 per voce, cosa comprende ogni prezzo, come funziona il viaggio e cosa deve essere scritto nel piano di trattamento.
            </p>
            <p>
              Lo diciamo chiaramente: questa non è una guida indipendente. I prezzi pubblicati sono quelli di SkyDental e le richieste inviate da questo sito arrivano al team di SkyDental, che risponde in italiano.
            </p>
          </div>
        </div>
      </div>
    </section>;
}